import { render, staticRenderFns } from "./order-add-or-update.vue?vue&type=template&id=8e6cd88e&scoped=true&"
import script from "./order-add-or-update.vue?vue&type=script&lang=js&"
export * from "./order-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./order-add-or-update.vue?vue&type=style&index=0&id=8e6cd88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6cd88e",
  null
  
)

export default component.exports